import script from "./LoadWindow.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoadWindow.vue?vue&type=script&lang=ts&setup=true"

import "./LoadWindow.vue?vue&type=style&index=0&id=3bbca132&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\stani\\OneDrive\\Documents\\Git\\fate-extended\\node_modules\\.pnpm\\vue-loader@17.0.1_vue@3.2.45+webpack@5.75.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bbca132"]])

export default __exports__